<template>
  <!--Extras Case-1-->
  <div
    id="modalExtrasNeeded"
    class="modal s-modal s-modal--warning"
    tabindex="-1"
    role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">
            <div><i class="icon-warning"></i></div>
            <div>{{ dictionary.modalExtrasTitle }}</div>
          </div>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close">
            <i class="icon-close-light"></i>
          </button>
        </div>
        <div class="modal-body">
          <p>{{ dictionary.modalExtrasNeededText }}</p>

          <ul class="b-extras-as-badges-list mb-20">
            <li v-for="(item, index) in childs" :key="index">
              <ExtrasBadge :id="item" :options="options" />
            </li>
          </ul>

          <p>{{ dictionary.modalExtrasNeededInfoText }}</p>
        </div>
        <div class="modal-footer">
          <ul>
            <li>
              <button
                type="button"
                class="btn btn-outline-danger btn-full-width"
                data-bs-dismiss="modal"
                @click="onClickUndo">
                {{ dictionary.modalExtrasButtonCancelText }}
              </button>
            </li>
            <li>
              <button
                type="button"
                class="btn btn-primary btn-full-width"
                data-bs-dismiss="modal"
                @click="onClickSubmit">
                OK
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExtrasBadge from './ExtrasBadge.vue'

export default {
  components: { ExtrasBadge },
  props: {
    master: {
      required: false,
      type: String,
      default: '',
    },
    childs: {
      required: false,
      type: Array,
      default: () => [],
    },
    options: {
      required: true,
      type: Array,
    },
  },
  emits: ['submit', 'undo'],
  methods: {
    onClickUndo() {
      this.$emit('undo', this.master)
    },

    onClickSubmit() {
      this.$emit('submit', this.childs)
    },
  },
}
</script>
